import { Button, Form, Select, Radio, Checkbox, RadioChangeEvent, Row, Col, Divider, Input } from 'antd';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { addConnTypeBodySize, modifyConnTypeBodySize, modifyConnTypeSubComp, addConnTypeSubComp } from './fittingTypeSlice';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export default function AddSubComponent({ SubCompData, formValue }: any): JSX.Element {
    const dispatch = useDispatch();
    const [isDisabled, setIsDisabled] = useState(false);

    const { setModelChangeBS, setModelChangeSubComp, editBs, setEditBS, isPref, setisPref, prefData, setPrefData, editData, setEditData } = React.useContext(CommonContext) as CommonContextType;

    const [fileList, setFileList] = useState<any>();
    const [file, setFile] = useState<any>()
    const [form] = Form.useForm();
    const [body_size_array, setBodySizeArray] = useState([{}]);
    const [cat_array, setCatArray] = useState([{}]);
    const BodySizes = useSelector((state: AppState) => state.BodySizes);
    const Category = useSelector((state: AppState) => state.Category);
    React.useEffect(() => {
        if (SubCompData[1]?.id) {
            let edit_Data = { ...SubCompData[1] }; // Make a shallow copy of SubCompData[1]

            // editData.mapping_pipe_type_rec.forEach((i: any) => {
            //     const pipeTpeId = i.pipe_type.id;
            //     const value = i.value;
            //     editData[`pipe_type_name_${pipeTpeId}`] = value;
            // });
            form.setFieldsValue(edit_Data)
        } else {
            form.resetFields();
            form.setFieldsValue(null)
        }
    }, [SubCompData, form, editData]);


    const onFinish = (values: any) => {
        // values.body_size = values.body_sizes
        // delete (values.body_sizes)
        // values.con_type_con_size = SubCompData[1]?.id
        // if (values?.preferential == true || values?.preferential == false) {
        //     values.preferential = values.preferential
        // }

        if (SubCompData[0]?.id && SubCompData[1]?.id) {
            values.updated_datetime = new Date().toLocaleString() + "";
            values.sub_comp = SubCompData[0]?.id
            dispatch(modifyConnTypeSubComp(values, SubCompData[1]?.id))

        } else if (SubCompData[0]?.id && !SubCompData[1]?.id) {
            values.created_datetime = new Date().toLocaleString() + "";
            values.sub_comp = SubCompData[0]?.id
            dispatch(addConnTypeSubComp(values))
        } else {
            values.created_datetime = new Date().toLocaleString() + ""
            // dispatch(addConnTypeBodySize(values))
            formValue(values);
        }
        // setModelChangeBS(false);
        form.resetFields();
        setEditBS(null)
        setEditData(null)
        setModelChangeSubComp(false);
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };


    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
        if (e.target.checked == true) {
            setisPref(true);
        } else {
            setisPref(false);
        }
    };

    let onChange_split_nut = (e: CheckboxChangeEvent) => {
        console.log(`split nut checked = ${e.target.checked}`);
    };
    // const onChangeSelect = (e: RadioChangeEvent) => {
    //     console.log("radio", e.target.value)
    //     if (e.target.value == 'Released') {
    //         setPrefData(true);
    //     } else if (e.target.value == 'Not Released') {
    //         setPrefData(false)
    //     } else if (e.target.value == 'Under Construction') {
    //         setPrefData(false)
    //     }


    // };

    const props = {
        showUploadList: {
            showRemoveIcon: false,
            showPreviewIcon: false,
        },
    }
    return (
        <div>

            <Divider style={{ borderColor: '#018B98', marginBottom: '6px' }} />
            <span><b><u>Body Size Details:</u></b></span>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <div style={{ width: '25%' }}><b>Body Size:</b> {SubCompData[0]?.body_size} </div>
            </div>
            <Divider style={{ borderColor: '#018B98', marginTop: '10px' }} />

            <Form
                form={form}
                layout={'vertical'}
                initialValues={{
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >


                <Form.Item label="Component Technical Name"
                    name='comp_tech_name'
                    rules={[
                        {
                            required: true,
                            message: 'Please enter Component Technical Name',
                        },
                    ]}>
                    <Input />
                </Form.Item>


                <Form.Item label="Component Functional Name"
                    name='comp_func_name'
                    rules={[
                        {
                            required: true,
                            message: 'Please enter Component Functional Name',
                        },
                    ]}>
                    <Input />
                </Form.Item>


                <Form.Item label="Quantity"
                    name='quantity'
                    rules={[
                        {
                            required: true,
                            message: 'Please enter Quantity',
                        },
                        {
                            pattern: /^[0-9]+$/,
                            message: 'Please enter numbers only',
                        },
                    ]}>
                    <Input />
                </Form.Item>

                <Form.Item>
                    <Button className='submit-button' type="primary" htmlType="submit" >{SubCompData[1]?.id ? 'Update' : 'Create'}</Button>
                </Form.Item>
            </Form>
        </div>
    )
}
